<template>
  <button :class="classString" @click="click">{{ buttonString }}</button>
</template>
<script>
export default {
  props: ['type', 'id'],
  data() {
    return {
      classString: '',
      buttonString: '',
    }
  },
  mounted() {
    switch (this.type) {
      case 'edit':
        this.classString = 'btn btn-primary btn-xs'
        this.buttonString = this.$t('common.edit')
        break
      case 'destroy':
        this.classString = 'btn btn-danger btn-xs'
        this.buttonString = this.$t('common.delete')
        break
      case 'config':
        this.classString = 'btn btn-info btn-xs'
        this.buttonString = this.$t('common.setting')
        break
      case 'display':
        this.classString = 'btn btn-warning btn-xs'
        this.buttonString = this.$t('common.display')
        break
      case 'normalImageDisplay':
        this.classString = 'btn btn-warning btn-xs'
        this.buttonString = this.$t('common.display')
        break
      case 'normalImageDestroy':
        this.classString = 'btn btn-danger btn-xs'
        this.buttonString = this.$t('common.delete')
        break
      case 'wideImageDisplay':
        this.classString = 'btn btn-warning btn-xs'
        this.buttonString = this.$t('common.display')
        break
      case 'wideImageDestroy':
        this.classString = 'btn btn-danger btn-xs'
        this.buttonString = this.$t('common.delete')
        break
      case 'itemAdd':
        this.classString = 'btn btn-info btn-xs'
        this.buttonString = this.$t('common.add')
        break
    }
  },
  methods: {
    click: function() {
      this.$emit('buttonClickEvent', this.type, this.id)
    },
  },
}
</script>
